import Enrouler from "./Enrouler";
import "./Presentation.css";

function Presentation() {
  return (
    <div className="presentation">
      <br></br>
      <div className="questions">
        <Enrouler title="QU’EST-CE QUE C’EST ?">
              Des outils de Rétablissement qui mélangent informations sur la psychiatrie de
              manière vulgarisées, mon témoignage de personne rétablie et des illustrations réalisées par
              mes soins.
        </Enrouler>

        <Enrouler title="QUEL EST L'OBJECTIF ?">
          Parler d’une thématique psychiatrique, informer et ouvrir le dialogue. 
          L’important étant que la personne concernée par le trouble psychique puisse exprimer sa version du sujet.
                
        </Enrouler>

        <Enrouler title="POUR QUI ?">
        Pour les personnes atteintes d’un trouble psychique, les aidants, les professionnels. 
        Quiconque souhaitant se sensibiliser aux sujets de la psychiatrie de manière vulgarisée.  
        Je déconseille la lecture des outils aux moins de 14 ans car certains sujets peuvent heurter.
        </Enrouler>

        <Enrouler title="ÇA SE PRÉSENTE COMMENT ?">
          Des livrets en format A5 et de 20 pages maximum.
        Le papier est épais pour faciliter la lecture et la relecture sans crainte de les abîmer.
        Ces livrets ont des textes concis avec des illustrations personnalisées aux contextes abordés.
        La lecture reste donc fluide et accessible.
        </Enrouler>
        
        <Enrouler title="COMMENT LES UTILISER ?">
        Dans un entretien ou dans la volonté de comprendre la personne souffrant d'un trouble,
        les outils peuvent être une opportunité d'approfondir le sujet thème du livret.
        L’utilisation en groupes de parole peut être très intéressante et enrichissante.
        Ils peuvent servir de complément à d'autres outils du médico-social et étoffer le savoir des professionnels et proches.
        </Enrouler>
      </div>
 
    </div>
  );
}

export default Presentation;
